import styled, { css } from 'styled-components';
import VariantButton from '../variant-button';

export default styled(VariantButton)`
  padding: 10px 10px;
  font-size: .8rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    width: auto;
    padding: 15px 40px;
    font-size: 1rem;
  }

  ${({ $fullWidth }) => $fullWidth && css`
    width: 100%;
    padding: 15px 40px;

    @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
      width: auto;
      padding: 15px 40px;
    }
  `}
`;
